import { html, ref, repeat } from '@microsoft/fast-element';
import { AllVppas } from './all-vppas';
import { VPPA_COLUMNS } from './column-config';

export const AllVppasTemplate = html<AllVppas>`
  <zero-grid-pro
    class="grid-styles chevron-count no-row-action-button"
    only-template-col-defs
    rowSelection="single"
    groupDisplayType="custom"
    persist-column-state-key=${(x) => x.currentStateKey}
    @onGridReady="${(x) => x.onGridReady()}"
    ${ref('vppaGrid')}
  >
    ${repeat(
      (x) => VPPA_COLUMNS(x),
      html`
        <grid-pro-column :definition="${(x) => x}"></grid-pro-column>
      `,
    )}
  </zero-grid-pro>
`;
